/*
 * Wall Art Landing Page - Carousel
 *
 **/

const $carousel = $('.js-auto-carousel');
const WIDTH_BREAKPOINT = 560; // Mobile breakpoint, consistent when $grid-small in variables.scss
let isSlick = false;

custom.autoCarousel = (() => {

function initSlick() {
  $carousel.slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    draggable: false,
    infinite: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    speed: 12000,
    variableWidth: true,
  });
}

function destroySlick() {
  $carousel.slick('unslick');
}

function slickHandler() {
  const windowWidth = $(window).width();

  if (!isSlick && windowWidth >= WIDTH_BREAKPOINT) {
    initSlick();
    isSlick = true;
  }

  if (isSlick && windowWidth < WIDTH_BREAKPOINT ) {
    destroySlick()
    isSlick = false;
  }
}

function init() {
  slickHandler();
  $(window).on('resize', slickHandler);
}

return {
  init: init
};
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/auto-carousel.js